import { TFunction } from "i18next";

export const getTabItems = (t: TFunction) =>
    [
        t("documentsLabel.mydocuments"),
        t("documentsLabel.shared.documents"),
        t("documentsLabel.mission.documents"),
        t("documentsLabel.shared_with_me.documents"),
    ] as const;

export type TabItem = ReturnType<typeof getTabItems>[number];
